const Section = ({ 
  title, 
  subtitle, 
  children, 
  className = "",
  gradient = false,
  centerTitle = true,
  ...props
}) => (
  <section className={`py-20 ${gradient ? 'bg-gradient-primary text-white relative overflow-hidden' : ''} ${className}`} {...props}>
    {gradient && <div className="absolute inset-0 bg-black/20"></div>}
    <div className="container mx-auto px-4 relative z-10">
      {(title || subtitle) && (
        <div className={`mb-16 ${centerTitle ? 'text-center' : ''}`}>
          {title && (
            <h2 className="text-4xl font-bold mb-4">
              {title}
            </h2>
          )}
          {subtitle && (
            <p className={`text-xl ${gradient ? 'opacity-90' : 'text-muted-foreground'} ${centerTitle ? 'max-w-2xl mx-auto' : ''}`}>
              {subtitle}
            </p>
          )}
        </div>
      )}
      {children}
    </div>
  </section>
)

export default Section